import { useContext, useRef, useState } from "react";
import { BsAlarm, BsMagic, BsXLg } from "react-icons/bs";
import { ActivateWizardModule } from "../../Logic/Enquiries/activateWizard";
import { GlobalModalContext } from "../../contexts/GlobalModalContext";
import TimeSlots from "./timeSlots";
import useOutsideClick from "../../hooks/useOutsideClick";
import { EnquiryGridSelectionContext } from "../../contexts/enquiry-grid-selection.context";
import { useAppDispatch } from "../../state/store";
import { getLastTouched, saveLastTouched } from "../../Logic/LastTouched/misc";
import { resetSort } from "../../utilities/sort";
import { LoadActiveMyEnquiries } from "../../Logic/Enquiries/Load";
import { setShowEnquiry, setShowWizard } from "../../state/restrictedViewSlice";
import { setEnquiriesVisibility } from "../../state/siteSlice";
import { switchFirstTab } from "../../state/tabRow";
import { alarmsDTO, DeleteUserAlarmsData } from "./tenantApiCalls";

type alarmInfoProp = {
    data: alarmsDTO;
    onClose: () => void;
};
interface timeslotIntervals {
    displayName: string;
    value: number;
}
export const dateTimeFormatN22 = (dateTime: string) => {
    try {
        return new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        })
            .format(new Date(dateTime))
            .replace(",", "");
    } catch (err) {
        return dateTime;
    }
};
function Index(props: alarmInfoProp) {
    const showModal = useContext(GlobalModalContext);
    const [isExpanded, setIsExpanded] = useState(false);
    const [IsSnoozedClicked, setIsSnoozedClicked] = useState(false);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const alarmRef = useRef<HTMLDivElement>(null);
    const dispatch = useAppDispatch();
    const { selectionProperties, SetEnquiryGridSelectionProperties } = useContext(EnquiryGridSelectionContext);

    useOutsideClick(alarmRef, () => setIsSnoozedClicked(false));
    const timeslots: timeslotIntervals[] = [
        { displayName: "5 minutes", value: 5 },
        { displayName: "10 minutes", value: 10 },
        { displayName: "15 minutes", value: 15 },
        { displayName: "20 minutes", value: 20 },
        { displayName: "30 minutes", value: 30 },
        { displayName: "1 hour", value: 60 },
        { displayName: "2 hour", value: 120 },
        { displayName: "6 hour", value: 360 },
        { displayName: "24 hour", value: 1440 },
    ];

    const handleExpandClick = () => {
        setIsExpanded(!isExpanded);
    };
    const handleSnoozedClick = (event: any) => {
        setIsSnoozedClicked(!IsSnoozedClicked);
        setPosition({ x: event.clientX, y: event.clientY });
    };
    async function showActiveEnquiryInMyEnquiry(id: number) {
        const lastTouched = getLastTouched();
        lastTouched.lastActiveListType = lastTouched.MyEnquiries.ActiveList;
        lastTouched.MyEnquiries.EnquiryLists = [{ EnquiryId: id, CommId: 0, scrollPosition: 0, Name: "Unresolved" }];

        saveLastTouched(lastTouched);

        SetEnquiryGridSelectionProperties({ multiSelect: false, selectedEnquiries: [] });
        resetSort();
        await LoadActiveMyEnquiries();

        dispatch(setShowEnquiry(false));
        dispatch(setShowWizard(false));
        dispatch(switchFirstTab("My Enquiries"));
        dispatch(setEnquiriesVisibility());
        props.onClose();
    }
    function ActivateWizard() {
        dispatch(setShowEnquiry(false));
        dispatch(setShowWizard(false));
        dispatch(switchFirstTab("My Enquiries"));
        dispatch(setEnquiriesVisibility());
        new ActivateWizardModule().ActivateWizard(props.data.enquiryID, () => showModal({ type: "EnquiryLocked" }));
        props.onClose();
    }
    function DeleteAlarm(id: number) {
        DeleteUserAlarmsData(id);
        props.onClose();
    }
    return (
        <>
            <div className="userAlarms-container">
                <div className="userAlarms-row">
                    <h2
                        className="userAlarms-subject"
                        title="Go to enquiry"
                        onClick={() => showActiveEnquiryInMyEnquiry(props.data.enquiryID)}
                    >
                        {props.data.subject}
                    </h2>
                    {IsSnoozedClicked}
                    <button
                        className="userAlarms-button"
                        title="Snooze alarm"
                        onClick={handleSnoozedClick}
                    >
                        <BsAlarm size={12}></BsAlarm>
                    </button>
                    <button
                        className="userAlarms-button"
                        title="Activate Wizard"
                    >
                        <BsMagic
                            onClick={() => ActivateWizard()}
                            size={12}
                        ></BsMagic>
                    </button>
                    <button
                        className="userAlarms-button"
                        title="Dismiss alarm"
                    >
                        <BsXLg
                            onClick={() => {
                                DeleteAlarm(props.data.id);
                            }}
                            size={12}
                        ></BsXLg>
                    </button>
                </div>

                {IsSnoozedClicked && (
                    <TimeSlots
                        alarmData={props.data}
                        slots={timeslots}
                        positionY={position.y}
                        positionX={position.x}
                        divRef={alarmRef}
                        onClose={props.onClose}
                    />
                )}

                <p className="userAlarms-body">
                    {" "}
                    {isExpanded ? props.data.notes : props.data.notes.substring(0, 50)}
                    {props.data.notes.length > 50 && (
                        <a
                            href="#"
                            className="userAlarms-expand-link"
                            onClick={handleExpandClick}
                        >
                            {" "}
                            {isExpanded ? "...collapse body" : "...expand body"}
                        </a>
                    )}
                </p>

                <p className="userAlarms-datetime">{dateTimeFormatN22(props.data.alarmAt.toString())}</p>
            </div>
        </>
    );
}
export default Index;
